<template>
<v-card style="height:90vh">

<v-toolbar height="42" color="#242F3B" dark flat>
<v-card-title class="ma-0 pa-0">
<span  style="font-size:1.4em">   Параметры автообновления </span>

</v-card-title>
<v-spacer></v-spacer>
<v-icon  @click="close()"> mdi-close</v-icon>
</v-toolbar>



<v-card-text>



<div>
<b-card no-body>
<b-tabs   card>

<b-tab>

<template #title>
<v-icon small color="#FF8F18">mdi-flash</v-icon> <strong style="margin-left:5px">Основное</strong>
</template>


<div>
<v-checkbox v-model="params.saveInfoOfSourceNewIn" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Запоминать куда подписался ?</span>
</v-checkbox>
</div>
<div v-show="false">
<v-checkbox v-model="params.stopThenFound"    color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Прерывать обновление сообщества, если найден хотя бы 1 новый подписчик ?</span>
</v-checkbox>
</div>


<div style="margin-top:15px">
<v-checkbox v-model="params.jail.is" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Запретить сообществу автообновление, если автообновление вернуло пустой результат ?</span>
</v-checkbox>
<v-layout v-if="params.jail.is" style="margin-left:15px">
<v-flex md5>
<v-subheader>Минуты запрета</v-subheader>
<v-slider v-model="params.jail.minutes"
max="360"
min="1"
color="primary"
thumb-label="always"
></v-slider>
</v-flex>


</v-layout>
</div>

<div v-show="false">
<b-alert show variant="info">
Количество потоков парсера, оптимально 1 поток на 50 аккаунтов.
</b-alert>
<v-layout style="margin-left:15px">
<v-flex md5>
<v-subheader>Потоки</v-subheader>
<v-slider v-model="params.streamCount"
max="50"
min="1"
color="primary"
thumb-label="always"
></v-slider>
</v-flex>


</v-layout>
</div>



</b-tab>


<b-tab>

<template #title>
<v-icon small color="yellow">mdi-export</v-icon> <strong style="margin-left:5px">Автоэкспорт в задания</strong>
</template>

<v-autocomplete
v-model="params.tasks.selectedTasksForNewFollowers"
no-data-text = "Нет заданий для выбора"
:items="taskList.tasksAllForNewFollowers"
hide-selected
chips
color="#FF8F18"
item-text="name"
item-value="task_id"
multiple
>
<template slot="label">
<span style="color:#FF8F18">Выберите задания для экспорта новых подписчиков</span>
</template>

<template slot="selection" slot-scope="data">
<v-chip
:selected="data.selected" close class="chip--select-multi" @input="removeSelectedTaskForNewFollowers(data.item)">
<v-avatar> <v-icon>mdi-account-multiple</v-icon> </v-avatar>
{{ data.item.name }}
</v-chip>
</template>

<template slot="item" slot-scope="data">
<template v-if="typeof data.item !== 'object'">
<v-list-tile-content v-text="data.title"></v-list-tile-content>
</template>
<template v-else>
<v-list-tile-avatar> <v-icon>mdi-account-multiple</v-icon></v-list-tile-avatar>
<v-list-tile-content>
<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
</v-list-tile-content>
</template>
</template>
</v-autocomplete>

<v-autocomplete
v-model="params.tasks.selectedTasksForNewFollowersOut"
no-data-text = "Нет заданий для выбора"
:items="taskList.tasksAllForNewFollowersOut"
hide-selected
chips
color="#FF8F18"
item-text="name"
item-value="task_id"
multiple
>
<template slot="label">
<span style="color:#FF8F18">Выберите задания для экспорта новых отписок</span>
</template>

<template slot="selection" slot-scope="data">
<v-chip :selected="data.selected" close class="chip--select-multi" @input="removeSelectedTaskForNewFollowersOut(data.item)">
<v-avatar> <v-icon>mdi-account-multiple</v-icon> </v-avatar>
{{ data.item.name }}
</v-chip>
</template>

<template slot="item" slot-scope="data">
<template v-if="typeof data.item !== 'object'">
<v-list-tile-content v-text="data.title"></v-list-tile-content>
</template>
<template v-else>
<v-list-tile-avatar>
<v-icon>mdi-account-multiple</v-icon>
</v-list-tile-avatar>
<v-list-tile-content>
<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
</v-list-tile-content>
</template>
</template>
</v-autocomplete>

</b-tab>

</b-tabs>
</b-card>
</div>

<v-btn style="text-transform:none"   color="#4A76A8"   flat @click="saveParams()" block>
<v-icon> mdi-content-save</v-icon> <span style="margin-left:5px">Сохранить настройки</span>
</v-btn>

</v-card-text>
<v-snackbar v-model="sb.snackbar" :color="sb.color" absolute top :timeout="2000">
{{sb.text}}
<v-btn dark flat @click="sb.snackbar = false">ОК</v-btn>
</v-snackbar>
</v-card>

</template>
<script>

import axios from 'axios'
export default {
components:{},
props: ['modals','groups'],
data () {
return {
params:{
is:false,
saveInfoOfSourceNewIn:true,
stopThenFound:false,
jail:{
is:false,
minutes:15,
},
streamCount:1,
tasks:{
selectedTasksForNewFollowers:[],
selectedTasksForNewFollowersOut:[],
},
},
taskList:{
tasksAllForNewFollowers:[],
tasksAllForNewFollowersOut:[],
},
sb:{
snackbar: false,
color: 'success',
text: ''
},
}
},
methods:{
close(){
this.$router.go()
},

removeSelectedTaskForNewFollowers (item) {
const index = this.params.tasks.selectedTasksForNewFollowers.indexOf(item.task_id)
if (index >= 0) this.params.tasks.selectedTasksForNewFollowers.splice(index, 1)
},
removeSelectedTaskForNewFollowersOut (item) {
const index = this.params.tasks.selectedTasksForNewFollowersOut.indexOf(item.task_id)
if (index >= 0) this.params.tasks.selectedTasksForNewFollowersOut.splice(index, 1)
},


getTasks(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
method: 'POST',
data: {contentType: 'pages'}
})
.then( response => {
this.taskList.tasksAllForNewFollowers = response.data
this.taskList.tasksAllForNewFollowersOut = response.data
})
},
saveParams(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/ch_update_params.php', {
method: 'POST',
data: {params: this.params}
})
.then( response => {
this.sb.text = "Настройки автообновления успешно изменены"
this.sb.snackbar = true
setTimeout(()=>{this.$router.go()}, 300)
})
},
getParams(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/get_update_params.php', {
method: 'GET'
})
.then( response => {
this.groups.update_params = response.data.params
this.params = Object.assign(this.params, response.data.params);
//this.params = response.data.params

})
},
},
computed:{
},
mounted(){
this.getTasks()
this.getParams()
},

}
</script>

<style    >

</style>
